import { createFileRoute, redirect } from "@tanstack/react-router";
import { RecommendTemplate } from "~/features/recommend/RecommendTemplate";
import { isRecommendTabApp } from "~/lib/applicationId";
import { useAuthStore } from "~/stores/useAuthStore";
import { consumePendingOnboarding } from "~/utils/pendingOnboarding";

export const Route = createFileRoute("/_authenticated/recommend/")({
  // おすすめ画面を持たないアプリは、直リンクで開かれても「さがす」へ戻す
  // 登録直後に WebView を開き直されてここに着いたら、オンボーディングへ戻す（さがす画面と同じ）
  beforeLoad: ({ preload }) => {
    if (!isRecommendTabApp()) throw redirect({ to: "/discover" });
    if (!preload && consumePendingOnboarding(useAuthStore.getState().userId)) {
      throw redirect({ to: "/onboarding" });
    }
  },
  component: RecommendTemplate,
});
